import { useLayoutEffect, useState } from 'react';

import { computeTooltipPosition } from '../functions/computeTooltipPosition';
import { TooltipPosition } from '../types/TooltipPosition';
import { UseTooltipPositionParams } from '../types/UseTooltipPositionParams';

export const useTooltipPosition = ({
  anchorRef,
  arrowRef,
  open,
  popperRef,
}: UseTooltipPositionParams): TooltipPosition => {
  const [position, setPosition] = useState<TooltipPosition>({
    arrowLeft: 0,
    left: 0,
    placement: 'bottom',
  });

  useLayoutEffect((): (() => void) | undefined => {
    if (!open) {
      return undefined;
    }

    const update = (): void => {
      const { clientHeight, clientWidth } = document.documentElement;

      setPosition(
        computeTooltipPosition({
          anchor: anchorRef.current.getBoundingClientRect(),
          arrowWidth: arrowRef.current.offsetWidth,
          popper: {
            height: popperRef.current.offsetHeight,
            width: popperRef.current.offsetWidth,
          },
          viewport: { height: clientHeight, width: clientWidth },
        }),
      );
    };

    update();

    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, { capture: true, passive: true });

    return (): void => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, { capture: true });
    };
  }, [open]);

  return position;
};
